import React from 'react'

function SendNotification() {
  return (
    <div>
      
    </div>
  )
}

export default SendNotification
